// LanguageAndCurrencySwitcher.jsx
import { useCurrency } from "@/contexts/CurrencyContext";
import { useLanguageAndCurrency } from "@/hooks/useLanguageAndCurrency";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CurrencySwitcher from "./CurrencySwitcher";
import LanguageSwitcher from "./LanguageSwitcher";
import { Button } from "./ui/Button";

const LanguageAndCurrencySwitcher = () => {
  const { hideLanguageAndCurrencyModal } = useCurrency();
  const t = useTranslationDetector();

  const {
    selectedCurrency,
    selectedLanguage,
    loading,
    handleCurrencyChange,
    handleLanguageChange,
    applyChanges,
  } = useLanguageAndCurrency();

  const handleComplete = () => {
    applyChanges(hideLanguageAndCurrencyModal);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <span className="flex flex-col">
          <span className="text-foreground text-lg font-semibold">
            {t("languageandcurrency.title")}
          </span>
          <p className="text-sm text-gray-500">
            {t("languageandcurrency.description")}
          </p>
        </span>
        <button
          className="cursor-pointer transition-colors hover:text-gray-400"
          onClick={hideLanguageAndCurrencyModal}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.far["xmark"]}
            className="text-xl"
          />
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <CurrencySwitcher
          handleCurrencyChange={handleCurrencyChange}
          value={selectedCurrency}
        />
        <LanguageSwitcher
          handleLanguageChange={handleLanguageChange}
          value={selectedLanguage}
        />

        <Button onClick={handleComplete} size="lg" loading={loading}>
          {t("languageandcurrency.save")}
        </Button>
      </div>
    </div>
  );
};

export default LanguageAndCurrencySwitcher;
